import { functions } from '../../firebase';
import { shopLiveWriteRegionError } from './jobsSurface';

export const CREATE_SHOP_JOB_CALLABLE = 'createShopJob';

export const CREATE_SHOP_JOB_CONFIRM_TITLE = 'Create pending job? (live write)';
export const CREATE_SHOP_JOB_CONFIRM =
    'LIVE WRITE. Create a pending job for this shop? createShopJob writes status pending only. It will not assign or activate. Client status/assignee are ignored. Cancel shows CREATE · CANCELLED and leaves Firestore unchanged. This is not CREATE · SOT — jobsSot=empty never writes. Zapier is not part of this path.';

export const TRUE_EMPTY_WALK_CONFIRM_TITLE = 'Confirm → createShopJob? (walk only)';
export const TRUE_EMPTY_WALK_CONFIRM =
    'WALK ONLY — createShopJob will not run. This is the same confirm step as the live true-empty path. On a real zero-job shop, confirming writes pending only. Auto World stays unchanged. Cancel paints CREATE · CANCELLED and does not call createShopJob. This is not CREATE · SOT.';

export const CREATE_SOT = {
    eyebrow: 'CREATE · SOT',
    headline: 'Paint-only — createShopJob did not run',
    body:
        'jobsSot=empty is not a true-empty shop. There was no confirm dialog. createShopJob did not run. Auto World is unchanged. The live true-empty path is confirm → createShopJob pending only.',
    cta: 'Exit SoT',
    href: '/app/jobs',
    note:
        'This is not a live write. Hosting honors jobsSot for a signed-in shop user. Use TRUE EMPTY · WALK (?trueEmptySot=walk) to see the confirm step without emptying Auto World. Direct Firestore job creates are blocked — they miss appointmentAt and createdBy.',
};

export const CREATE_TRUE_EMPTY_CONFIRM = {
    eyebrow: 'TRUE EMPTY · CONFIRM',
    headline: 'Confirm step complete — no write',
    body:
        'createShopJob did not run. Auto World is unchanged. On a real zero-job shop, this same confirm writes pending only. SoT EMPTY (jobsSot=empty) never shows this confirm.',
    cta: 'Exit walk',
    href: '/app/jobs',
    note:
        'Hosting honors trueEmptySot for a signed-in shop user. This walk is not CREATE · SOT and not a live write.',
};

export const CREATE_PREVIEW = {
    eyebrow: 'CREATE · PREVIEW',
    headline: 'Local preview — createShopJob did not run',
    body:
        'JOBS · EMPTY is a local CRA preview. Hosting production ignores jobsPreview. Nothing was written to this shop.',
    cta: 'Back',
    note: 'Use ?jobsSot=empty on Hosting to prove the same Create job CTA without a zero-job shop.',
};

export const CREATE_OFFLINE = {
    eyebrow: 'CREATE · OFFLINE',
    headline: 'You are offline',
    body:
        'The shop portal cannot create a job without a connection. This is not an empty shop and not a successful create. createShopJob was not called.',
    cta: 'Retry',
    note: 'Reconnect, then create. Cached counts stay hidden. This is not JOBS · EMPTY.',
};

export const CREATE_DENIED = {
    eyebrow: 'CREATE · DENIED',
    headline: 'Shop claims are incomplete',
    body:
        'Create job needs a shop user session with shopId and regionId. The portal will not invent a shop or write a job without those claims.',
    cta: 'Back',
    note: 'Sign in as a shop user. This is not JOBS · EMPTY.',
};

export const CREATE_FIXTURE_REGION = {
    eyebrow: 'CREATE · DENIED',
    headline: 'Fixture region is not a live write',
    body: 'preview-test-region is a Hosting fixture label, not a Firestore region. createShopJob did not run.',
    cta: 'Back',
    note:
        'Set shop claims regionId to the Firestore region named Test Region (and shopId to a shop under it), then sign in again. jobsSot walks may still label Test Region as preview-test-region. That label does not write.',
};

export const CREATE_ERROR = {
    eyebrow: 'CREATE · ERROR',
    headline: 'createShopJob could not run',
    body:
        'The pending job was not written. This is not an empty shop and not a successful create. Status stays unchanged. The shop portal does not fall back to a client Firestore add.',
    cta: 'Retry',
    note:
        'Confirm you are a Glass shop user on techrepair-glass, then retry. Only createShopJob writes the job. Client status/assignee are ignored. Zapier is not part of this path.',
};

export const CREATE_PENDING = {
    eyebrow: 'CREATE · PENDING',
    headline: 'Job is pending',
    body:
        'createShopJob returned status pending. The shop portal does not assign or activate. Only assignJob writes active.',
    cta: 'Back to jobs',
    note: 'The new job appears on the live list after this modal closes. Admin Live jobs Pending follows without a hard refresh. This is not JOBS · EMPTY.',
};

/** Confirm dismiss is a visible create card. createShopJob did not run. This is not a callable failure. */
export const CREATE_CANCELLED = {
    eyebrow: 'CREATE · CANCELLED',
    headline: 'Create confirm was cancelled',
    body:
        'The confirm dialog was cancelled or dismissed. createShopJob was not called. No pending job was written. The form can be retried. This is not a callable failure.',
    cta: 'Back to form',
    note:
        'Accept the confirm to continue. Cancel writes nothing. Back to form keeps the create form usable. Only assignJob writes active. This is not CREATE · ERROR.',
};

export const CREATE_FIXTURE_NOTICE = {
    sot:
        'CREATE · SOT — submit skips confirm and does not call createShopJob. Auto World is unchanged. This is not the true-empty live write.',
    preview:
        'CREATE · PREVIEW — local CRA only. Submit skips confirm and does not call createShopJob. Hosting production ignores jobsPreview.',
    'true-empty':
        'TRUE EMPTY · WALK — submit shows the confirm dialog. createShopJob will not run. Auto World is unchanged. On a real zero-job shop the same confirm writes pending only.',
    'true-empty-preview':
        'TRUE EMPTY · PREVIEW — local CRA only. Submit shows the confirm dialog. createShopJob will not run. Hosting production ignores trueEmptyPreview.',
};

export const CREATE_LIVE_EMPTY_NOTICE =
    'TRUE EMPTY · LIVE — submit asks to confirm, then createShopJob writes pending only. This is not CREATE · SOT (jobsSot=empty never writes).';

export const SHOP_CREATE_SOT_VALUES = ['error', 'offline', 'denied', 'pending'];
export const SHOP_CREATE_PREVIEW_VALUES = SHOP_CREATE_SOT_VALUES;
export const SHOP_CREATE_PAINT_FIXTURES = ['sot', 'preview', ...SHOP_CREATE_SOT_VALUES];
export const SHOP_TRUE_EMPTY_SOT_VALUES = ['walk'];
export const SHOP_TRUE_EMPTY_PREVIEW_VALUES = SHOP_TRUE_EMPTY_SOT_VALUES;
export const SHOP_TRUE_EMPTY_WALK_FIXTURES = ['true-empty', 'true-empty-preview'];

export const SHOP_CREATE_SOT_NOTICE =
    'Shop SoT fixture — CREATE · ERROR / OFFLINE / DENIED / PENDING helper cards. Hosting honors createSot for a signed-in shop user. createShopJob did not run. Auto World is unchanged without this query. CREATE · PENDING paints the live Create success card. Admin Live jobs Pending follows the same job without a hard refresh.';

export const SHOP_CREATE_PREVIEW_NOTICE =
    'Local preview — CREATE · ERROR / OFFLINE / DENIED helper cards. Hosting production ignores createPreview.';

export const SHOP_CREATE_SOT_DETAIL =
    'Shop SoT fixture — createShopJob did not run. Auto World is unchanged.';

export const SHOP_CREATE_PREVIEW_DETAIL =
    'Local preview — createShopJob did not run. Hosting production ignores createPreview.';

export const SHOP_TRUE_EMPTY_SOT_NOTICE =
    'TRUE EMPTY · WALK — confirm → createShopJob path without emptying Auto World. Hosting honors trueEmptySot for a signed-in shop user. createShopJob did not run. Auto World is unchanged. On a real zero-job shop the same confirm writes pending only.';

export const SHOP_TRUE_EMPTY_PREVIEW_NOTICE =
    'TRUE EMPTY · PREVIEW — local CRA only. Confirm step without a write. Hosting production ignores trueEmptyPreview.';

export const SHOP_TRUE_EMPTY_SOT_DETAIL =
    'TRUE EMPTY · WALK — createShopJob did not run. Auto World is unchanged.';

export const SHOP_TRUE_EMPTY_PREVIEW_DETAIL =
    'TRUE EMPTY · PREVIEW — createShopJob did not run. Hosting production ignores trueEmptyPreview.';

function queryParam(search, key) {
    if (!search) return null;
    const raw = String(search).startsWith('?') ? String(search).slice(1) : String(search);
    return new URLSearchParams(raw).get(key);
}

export function shopCreateSotSurface(search) {
    const value = queryParam(search, 'createSot');
    return SHOP_CREATE_SOT_VALUES.includes(value) ? value : null;
}

/** Hosting honors createSot only for a signed-in shop user. Local CRA can still use createPreview. */
export function shopCreateSotAllowed(input = {}) {
    return input.shopUser === true;
}

export function shopCreateSotActive(search, input = {}) {
    if (!shopCreateSotAllowed(input)) return null;
    const jobsSot = queryParam(search, 'jobsSot');
    if (jobsSot === 'empty' || jobsSot === 'error' || jobsSot === 'offline' || jobsSot === 'pending' || jobsSot === 'pending-handoff' || jobsSot === 'handoff' || jobsSot === 'complete-handoff') {
        return null;
    }
    return shopCreateSotSurface(search);
}

export function shopCreateSotHref(surface) {
    if (!SHOP_CREATE_SOT_VALUES.includes(surface)) return '/app/jobs';
    return `/app/jobs?createSot=${surface}`;
}

export function shopCreatePreviewSurface(search, env = process.env.NODE_ENV) {
    if (env === 'production') return null;
    const value = queryParam(search, 'createPreview');
    return SHOP_CREATE_PREVIEW_VALUES.includes(value) ? value : null;
}

/** Prefer Hosting-safe createSot, then CRA-only createPreview. */
export function shopCreateFixtureSurface(search, input = {}, env = process.env.NODE_ENV) {
    return shopCreateSotActive(search, input) || shopCreatePreviewSurface(search, env);
}

export function shopCreateFixtureNotice(search, input = {}, env = process.env.NODE_ENV) {
    if (shopCreateSotActive(search, input)) return SHOP_CREATE_SOT_NOTICE;
    if (shopCreatePreviewSurface(search, env)) return SHOP_CREATE_PREVIEW_NOTICE;
    return null;
}

export function shopCreateFixtureDetail(kind) {
    if (kind === 'sot') return SHOP_CREATE_SOT_DETAIL;
    if (kind === 'true-empty') return SHOP_TRUE_EMPTY_SOT_DETAIL;
    if (kind === 'true-empty-preview') return SHOP_TRUE_EMPTY_PREVIEW_DETAIL;
    return SHOP_CREATE_PREVIEW_DETAIL;
}

export function shopTrueEmptySotSurface(search) {
    const value = queryParam(search, 'trueEmptySot');
    return SHOP_TRUE_EMPTY_SOT_VALUES.includes(value) ? value : null;
}

/** Hosting honors trueEmptySot only for a signed-in shop user. Local CRA can still use trueEmptyPreview. */
export function shopTrueEmptySotAllowed(input = {}) {
    return input.shopUser === true;
}

export function shopTrueEmptySotActive(search, input = {}) {
    if (!shopTrueEmptySotAllowed(input)) return null;
    return shopTrueEmptySotSurface(search);
}

export function shopTrueEmptySotHref(surface = 'walk') {
    if (!SHOP_TRUE_EMPTY_SOT_VALUES.includes(surface)) return '/app/jobs';
    return `/app/jobs?trueEmptySot=${surface}`;
}

export function shopTrueEmptyPreviewSurface(search, env = process.env.NODE_ENV) {
    if (env === 'production') return null;
    const value = queryParam(search, 'trueEmptyPreview');
    return SHOP_TRUE_EMPTY_PREVIEW_VALUES.includes(value) ? value : null;
}

/** Prefer Hosting-safe trueEmptySot, then CRA-only trueEmptyPreview. */
export function shopTrueEmptyFixtureSurface(search, input = {}, env = process.env.NODE_ENV) {
    return shopTrueEmptySotActive(search, input) || shopTrueEmptyPreviewSurface(search, env);
}

export function shopTrueEmptyFixtureNotice(search, input = {}, env = process.env.NODE_ENV) {
    if (shopTrueEmptySotActive(search, input)) return SHOP_TRUE_EMPTY_SOT_NOTICE;
    if (shopTrueEmptyPreviewSurface(search, env)) return SHOP_TRUE_EMPTY_PREVIEW_NOTICE;
    return null;
}

export function shopTrueEmptyWalkKind(sotActive, previewActive) {
    if (sotActive) return 'true-empty';
    if (previewActive) return 'true-empty-preview';
    return null;
}

export function isTrueEmptyWalkFixture(fixture) {
    return SHOP_TRUE_EMPTY_WALK_FIXTURES.includes(fixture);
}

/** Hosting createSot / trueEmptySot / jobsSot win over local previews. Paint fixtures never write. */
export function shopCreateFixtureKind(sot, preview, createSot, createPreview, trueEmpty) {
    if (createSot) return createSot;
    if (createPreview) return createPreview;
    if (trueEmpty) return trueEmpty;
    if (sot === 'pending-handoff' || preview === 'pending-handoff') return null;
    if (sot === 'handoff' || preview === 'handoff') return null;
    if (sot === 'complete-handoff' || preview === 'complete-handoff') return null;
    if (sot) return 'sot';
    if (preview) return 'preview';
    return null;
}

export function shopCreateGuard(input = {}) {
    if (SHOP_CREATE_PAINT_FIXTURES.includes(input.fixture)) return input.fixture;
    if (input.offline) return 'offline';
    if (input.shopUser !== true || !input.shopId || !input.regionId) return 'denied';
    if (!isTrueEmptyWalkFixture(input.fixture) && shopLiveWriteRegionError(input.regionId)) return 'fixture-region';
    return null;
}

export function shopCreateCopy(surface) {
    if (surface === 'sot') return CREATE_SOT;
    if (surface === 'preview') return CREATE_PREVIEW;
    if (surface === 'true-empty' || surface === 'true-empty-preview') return CREATE_TRUE_EMPTY_CONFIRM;
    if (surface === 'offline') return CREATE_OFFLINE;
    if (surface === 'denied') return CREATE_DENIED;
    if (surface === 'fixture-region') return CREATE_FIXTURE_REGION;
    if (surface === 'error') return CREATE_ERROR;
    if (surface === 'pending') return CREATE_PENDING;
    if (surface === 'cancelled') return CREATE_CANCELLED;
    return null;
}

export function shopCreatePath(fixture, liveEmpty) {
    if (fixture === 'sot' || fixture === 'preview') return 'sot';
    if (isTrueEmptyWalkFixture(fixture)) return 'true-empty-walk';
    if (liveEmpty) return 'true-empty-live';
    return 'live';
}

function requiredCreateString(value, key) {
    const text = typeof value === 'string' || typeof value === 'number' ? String(value).trim() : '';
    if (!text) {
        throw new Error(`${key} is required.`);
    }
    return text;
}

export function buildCreateShopJobPacket(values = {}) {
    const appointment = new Date(values.date);
    if (Number.isNaN(appointment.getTime())) {
        throw new Error('Appointment time is required.');
    }
    if (appointment.getTime() <= Date.now() + 24 * 60 * 60 * 1000) {
        throw new Error('Appointment time has to be at least 24hrs in advance');
    }
    const vehicle = values.vehicle && typeof values.vehicle === 'object' ? values.vehicle : {};
    return {
        appointmentAt: appointment.toISOString(),
        customerName: requiredCreateString(values.customerName, 'customerName'),
        contact: requiredCreateString(values.contact, 'contact'),
        type: requiredCreateString(values.type, 'type'),
        damage: requiredCreateString(values.damage, 'damage'),
        year: requiredCreateString(vehicle.year, 'year'),
        make: requiredCreateString(vehicle.make, 'make'),
        model: requiredCreateString(vehicle.model, 'model'),
        insurance: requiredCreateString(vehicle.insurance, 'insurance'),
        dropped: typeof values.dropped === 'string' && values.dropped.trim() ? values.dropped.trim() : 'Currently dropped',
        waiting: values.waiting === true,
        notes: requiredCreateString(values.notes, 'notes'),
    };
}

export function parseCreateShopJobResult(data) {
    const result = data && typeof data === 'object' ? data : {};
    return {
        success: result.success === true,
        jobId: typeof result.jobId === 'string' ? result.jobId : '',
        regionId: typeof result.regionId === 'string' ? result.regionId : '',
        shopId: typeof result.shopId === 'string' ? result.shopId : '',
        status: result.status === 'pending' ? 'pending' : '',
    };
}

export function shopCreateCallableError(error) {
    return error?.message || 'createShopJob could not run.';
}

export function callCreateShopJob(packet, httpsCallable = (name) => functions.httpsCallable(name)) {
    return httpsCallable(CREATE_SHOP_JOB_CALLABLE)(packet).then((res) => res?.data ?? res);
}

export async function createShopJobFromForm(values, callCreate = callCreateShopJob, regionId) {
    if (typeof regionId === 'string') {
        const regionError = shopLiveWriteRegionError(regionId);
        if (regionError) throw new Error(regionError);
    }
    const packet = buildCreateShopJobPacket(values);
    const data = await callCreate(packet);
    const parsed = parseCreateShopJobResult(data);
    if (!parsed.success || parsed.status !== 'pending' || !parsed.jobId) {
        throw new Error('createShopJob did not return a pending job.');
    }
    return parsed;
}
